import React, { useState } from 'react';
import { SiteSection } from '../../components/site';
import type { SolutionExperienceJourney } from './types';

export const SolutionManufacturingLifecycle: React.FC<{
  journey: SolutionExperienceJourney;
}> = ({ journey }) => {
  const [activeStep, setActiveStep] = useState(journey.steps[0]?.step ?? 1);

  return (
    <SiteSection
      id="experience-journey"
      tone="muted"
      className="solution-journey solution-journey--manufacturing mf-lifecycle"
    >
      <header className="mf-lifecycle__header mf-lifecycle__header--center">
        <p className="io-site-section__eyebrow">{journey.eyebrow}</p>
        <h2 className="io-site-section__title">{journey.title}</h2>
        <p className="io-site-section__subtitle">{journey.subtitle}</p>
      </header>

      <div className="mf-lifecycle__accordion" role="tablist" aria-label={journey.title}>
        {journey.steps.map((step) => {
          const isActive = step.step === activeStep;
          const num = String(step.step).padStart(2, '0');
          const tabId = `mf-lifecycle-tab-${step.step}`;
          const panelId = `mf-lifecycle-panel-${step.step}`;

          return (
            <button
              key={step.step}
              id={tabId}
              type="button"
              role="tab"
              aria-selected={isActive}
              aria-controls={panelId}
              className={`mf-lifecycle__item${isActive ? ' is-active' : ''}`}
              onClick={() => setActiveStep(step.step)}
              onMouseEnter={(e) => {
                setActiveStep(step.step);
                e.currentTarget.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }}
            >
              <span className="mf-lifecycle__num" aria-hidden>
                {num}
              </span>
              <span
                id={panelId}
                role="tabpanel"
                aria-labelledby={tabId}
                className="mf-lifecycle__content"
              >
                <span className="mf-lifecycle__title">{step.title}</span>
                {isActive ? (
                  <>
                    <span className="mf-lifecycle__desc">{step.description}</span>
                    {step.bullets && step.bullets.length > 0 ? (
                      <ul className="mf-lifecycle__bullets">
                        {step.bullets.map((bullet) => (
                          <li key={bullet}>{bullet}</li>
                        ))}
                      </ul>
                    ) : null}
                  </>
                ) : null}
              </span>
            </button>
          );
        })}
      </div>
    </SiteSection>
  );
};
